import * as React from 'react';
import { Accordion as RAccordion, AccordionItem, AccordionButton, AccordionPanel } from '@reach/accordion';
// Design system
import { Font } from 'src/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
import { Slice } from '@utmb/types/slice-handler';
import { SliceAccordionView, SliceAccordionItemView } from 'src/types';
// Utils
import { parseMarkdown } from '@utmb/utils/markdown';
// Styles
import styles from './accordion.module.scss';
import '@reach/accordion/styles.css';
import { useGlobal } from '@utmb/contexts/GlobalContext';


const { FuturaBook, FuturaHeavy } = Font;

const Accordion = (props: Slice<SliceAccordionView>): React.ReactElement => {
    const { id, items } = props;

    const {
        global: {
            event: { primaryColorIsDark },
        },
    } = useGlobal();

    return (
        <div id={id} className={`${styles.root} container`}>
            <div className="row">
                <div className="col-md-10 offset-md-1">
                    <RAccordion collapsible multiple>
                        {items &&
                            items.map((item: SliceAccordionItemView) => {
                                return (
                                    <AccordionItem key={item.id}>
                                        <h3>
                                            <AccordionButton>
                                                <FuturaHeavy mobile="24" as="span">
                                                    {item.title}
                                                </FuturaHeavy>
                                                <Icon color="#000" variant={IconsEnum.CHEVRON_UNCONSTRAINED} clss={styles.svg} />
                                            </AccordionButton>
                                        </h3>
                                        <AccordionPanel>
                                            {item.content && (
                                                <FuturaBook mobile="16" as="div">
                                                    <div className={`markdown ${primaryColorIsDark ? 'primaryColorIsDark' : ''}`} dangerouslySetInnerHTML={{ __html: parseMarkdown(item.content) }} />
                                                </FuturaBook>
                                            )}
                                        </AccordionPanel>
                                    </AccordionItem>
                                );
                            })}
                    </RAccordion>
                </div>
            </div>
        </div>
    );
};

export default Accordion;
